import { useMemo } from 'react'
import { useChatContext } from '@almai1/chatbot-widget'
import { useTranslation } from 'react-i18next'

export function TypingIndicator() {
  const { t } = useTranslation()
  const { isTyping, isTranscribing, timeline } = useChatContext()

  const toolStatus = useMemo(() => {
    for (let i = timeline.length - 1; i >= 0; i--) {
      const item = timeline[i] as any
      if (item.type === 'toolStatus') {
        return item.data?.statusMessage as string | undefined
      }
    }
    return undefined
  }, [timeline])

  if (!isTyping && !isTranscribing) return null

  return (
    <div className="widget-activity-indicator">
      {toolStatus ? (
        <span className="activity-indicator-content">{toolStatus}</span>
      ) : (
        <div className="widget-typing-quill">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
            <line x1="16" y1="8" x2="2" y2="22" />
            <line x1="17.5" y1="15" x2="9" y2="15" />
          </svg>
          <span className="widget-typing-quill-line" />
          <span className="widget-typing-label">{t('widget.typing')}</span>
        </div>
      )}
    </div>
  )
}
